import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

interface SaveSuccessIndicatorProps {
  isSuccess: boolean;
}

export default function SaveSuccessIndicator({ isSuccess }: SaveSuccessIndicatorProps) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isSuccess) {
      // A new save started (the mutation left `success`): hide right away. Without this, a save
      // begun within the 3 s window cancels the timer in the cleanup below and "Uloženo" would
      // stay up for good — even next to the error banner if that save fails.
      setShow(false);
      return;
    }
    // The effect runs only when `isSuccess` changes, so every false → true is a new save.
    setShow(true);
    const timer = setTimeout(() => setShow(false), 3000);
    return () => clearTimeout(timer);
  }, [isSuccess]);

  if (!show) return null;

  return (
    <span className="flex items-center gap-1.5 text-sm font-medium text-green-600">
      <Check className="h-4 w-4" />
      {t("common.states.saved")}
    </span>
  );
}
